import { Box, Button, CircularProgress, Grid, useMediaQuery } from '@material-ui/core'
import { CalendarToday, DateRange, Settings } from '@material-ui/icons'
import { array, bool, func } from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import Layout from '../../components/layout_admin'
import PageTitle from '../../components/page_title'
import Appointment from './apointment'

const EmptyTesxt = styled.div`
  text-align: center;
  font-size: 2em;
  color: #008ffd52;
  @media screen and (max-width:500px) {
    font-size: 1.7em;
  }
  
`

const DateRangeStyled = styled(DateRange)`
  color: #addbfebf;
  margin: auto;
  font-size: 120px;
  display: block;
  margin-top: 30px;
  @media screen and (max-width:500px) {
    font-size: 80px;
    margin-top: 20px;
  }
`

const View = props => {
  const isMd = useMediaQuery('(max-width:1280px)')

  return (
    <>
      <Layout title='Citas'>
        <Box mb={3}>
          <Grid container justify='space-between'>
            <Grid item xs><PageTitle>Citas</PageTitle></Grid>
            <Grid item xs container justify='center' wrap='nowrap'>
              <Button onClick={props.onSettingsOpen} variant='outlined' color='secondary' style={{ fontSize: isMd ? '.9em' : '1em', whiteSpace: 'nowrap', padding: '0px 1em', marginRight: '.5em' }}>
                <Settings style={{ marginRight: '.2em' }} />
                Ajustes
              </Button>
              <Button onClick={props.onDisableDaysOpen} variant='outlined' color='secondary' style={{ fontSize: isMd ? '.9em' : '1em', whiteSpace: 'nowrap', padding: '0px 1em' }}>
                <CalendarToday style={{ marginRight: '.2em' }} />
                Dias inhábiles
              </Button>
            </Grid>
            <Grid item xs />
          </Grid>
        </Box>
        {props.loading && (
          <Grid container justify='center' alignItems='center' style={{ minHeight: '85vh' }}>
            <CircularProgress color='secondary' />
          </Grid>
        )}
        {!props.loading && !props.items.length && (
          <Grid container justify='center' alignItems='center' style={{ minHeight: '85vh' }}>
            <Box style={{ flexGrow: 1 }}>
              <EmptyTesxt color='secondary' variant='h4'>Aun no hay Citas</EmptyTesxt>
              <DateRangeStyled />
            </Box>
          </Grid>
        )}
        {!!props.items.length && (
          <Grid container spacing={isMd ? 2 : 4}>
            {props.items.map((appointment, index) => (
              <Grid item key={index} xs={12} sm={6} md={4} xl={3}>
                <Appointment {...appointment} />
              </Grid>
            ))}
            {props.loading && (
              <Grid item xs={12} container justify='center' style={{ minHeight: '100px' }} alignItems='center'>
                <CircularProgress color='secondary' />
              </Grid>
            )}
          </Grid>
        )}
      </Layout>
    </>
  )
}

View.propTypes = {
  loading: bool,
  items: array,
  onSettingsOpen: func,
  onDisableDaysOpen: func
}

export default View
